import { createRoute, useParams } from '@tanstack/react-router';
import { BatchLedgerPage } from '@/features/stock/BatchLedgerPage';
import { Route as shellRoute } from '../_shell';

/**
 * The batch and WAC ledger. A full page, not a drawer, because it is a reconciliation
 * surface: every WAC cell in the product links here and the number has to be traceable.
 */
function LedgerRoute() {
  const { productId } = useParams({ from: '/stock/$productId/ledger' });
  return <BatchLedgerPage productId={Number(productId)} />;
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/stock/$productId/ledger',
  component: LedgerRoute,
});
